import { FaWhatsapp } from "react-icons/fa";

type WhatsappButtonProps = {
  /** Número en formato internacional SIN +, espacios ni guiones. Ej: "51951044951" */
  phone: string;
  /** Mensaje opcional */
  message?: string;

  /** Posición (por si luego lo quieres mover) */
  position?: "bottom-right" | "bottom-left";

  /** Clases extra de Tailwind para personalización */
  className?: string;

  /** Tamaño del ícono (px) */
  iconSize?: number;

  /** Si quieres deshabilitarlo por alguna condición */
  disabled?: boolean;
};

function normalizePhone(phone: string) {
  // deja solo dígitos (quita +, espacios, guiones, paréntesis)
  return phone.replace(/\D/g, "");
}

export default function WhatsappButton({
  phone,
  message = "Hola, me gustaria recibir mas información sobre el alquiler de las cabañas",
  position = "bottom-right",
  className = "",
  iconSize = 28,
  disabled = false,
}: WhatsappButtonProps) {
  const cleanPhone = normalizePhone(phone);
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${cleanPhone}?text=${encodedMessage}`;

  const pos =
    position === "bottom-left"
      ? "bottom-6 left-6"
      : "bottom-6 right-6";

  if (disabled) return null;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatear por WhatsApp"
      className={[
        "fixed z-[9999]",
        pos,
        "w-14 h-14 md:w-14 md:h-14",
        "rounded-full",
        "bg-[#25D366] text-white",
        "flex items-center justify-center",
        "shadow-2xl",
        "transition-all duration-300 ease-out",
        "hover:scale-110 hover:shadow-green-500/40",
        "active:scale-95",
        "select-none",
        className,
      ].join(" ")}
    >
      <FaWhatsapp style={{ fontSize: iconSize }} />
    </a>
  );
}
